import isNil from 'lodash/isNil'
import numeral from 'numeral'

export const filesBaseUrl = `${window.brumbrum.url_files}`

export const productImagePlaceholder = `${filesBaseUrl}/www2/images/placeholder/car.32.hi.jpg`

/**
 * BRUM-808 in questo modo sappiamo se c'e' bisogno di ricalcolare
 * i tre finanziamenti di default a fronte di un cambio nel totale ordine
 */
export const totaleOrdineEqualTotaleFinanziamento = (financements, totale) => {
  for (let i = 0; i < financements.length; i++) {
    const finanziamento = financements[i]
    const totaleFinanziamento =
      finanziamento.importo_finanziato + finanziamento.anticipo
    if (totaleFinanziamento !== totale) {
      return false
    }
  }

  return true
}
// eslint-disable-next-line camelcase
export const totale_ordine_equal_totale_finanziamento =
  totaleOrdineEqualTotaleFinanziamento

export const preparaValoriLogistica = (totale, logistica) => {
  let totalone = totale
  let prezzoLogisticaPromozione
  let prezzoLogistica
  let isFreePrice = false
  let numberOrText = 'number'
  const logisticaRaw = logistica
  if (!logistica.centro_convenzionato) {
    // supporto durante caricamento dati
    logisticaRaw.centro_convenzionato = {
      prezzo: 0,
    }
  } else if (logistica.centro_convenzionato.prezzo_listino === 0) {
    prezzoLogistica = 'Incluso'
    isFreePrice = true
    numberOrText = 'text'
  } else if (
    logistica.centro_convenzionato.prezzo ===
    logistica.centro_convenzionato.prezzo_listino
  ) {
    // logistica non in promozione
    prezzoLogistica = numeral(logistica.centro_convenzionato.prezzo).format(
      '$ 0,0[.]00'
    )
    totalone = logistica.centro_convenzionato.prezzo_listino + totalone
  } else if (
    logistica.centro_convenzionato.prezzo !==
    logistica.centro_convenzionato.prezzo_listino
  ) {
    // logistica in promozione
    prezzoLogisticaPromozione = numeral(
      logistica.centro_convenzionato.prezzo
    ).format('$ 0,0[.]00')
    prezzoLogistica = numeral(
      logistica.centro_convenzionato.prezzo_listino
    ).format('$ 0,0[.]00')
    totalone = logistica.centro_convenzionato.prezzo + totalone
    isFreePrice = true
  }
  const _totale = totalone
  totalone = numeral(totalone).format('$ 0,0[.]00')
  const centroConvenzionatoNome = logistica.centro_convenzionato.nome
  return {
    totalone,
    totale: _totale,
    prezzoLogisticaPromozione,
    prezzoLogistica,
    isFreePrice,
    centroConvenzionatoNome,
    numberOrText,
    logisticaRaw,
  }
}
// eslint-disable-next-line camelcase
export const prepara_valori_logistica = (totale, logistica) => {
  const valoriLostica = preparaValoriLogistica(totale, logistica)

  return {
    ...valoriLostica, // forward compatibility
    totalone: valoriLostica.totalone,
    prezzo_logistica_promozione: valoriLostica.prezzoLogisticaPromozione,
    prezzo_logistica: valoriLostica.prezzoLogistica,
    is_free_price: valoriLostica.isFreePrice,
    centro_convenzionato_nome: valoriLostica.centroConvenzionatoNome,
    number_or_text: valoriLostica.numberOrText,
  }
}

/**
 * BRUM-3792
 * @param product branch product dello state
 */
export const haGaranzia3Anni = garanzia => garanzia.nome === 'mapfre_3_anni'

export const mapfreAssistenzaStradale = `${filesBaseUrl}/pdf/brumbrum-3annigarantiti-programma_assistenza_stradale.pdf`

export const mapfreInformativaDatiPersonali = `${filesBaseUrl}/pdf/brumbrum-3annigarantiti-informativa_trattamento_dati_personali.pdf`

export const mapfreProgrammaGaranzia = `${filesBaseUrl}/pdf/brumbrum-3annigarantiti-programma_garanzia_convenzionale.pdf`

export const mapfreCondizioniGeneraliContratto = `${filesBaseUrl}/pdf/brumbrum-CGC_v16112022.pdf`

export const restartSelloutCheckpoints = {
  SCEGLI_CANONI: 'SCEGLI_CANONI',
  SERVIZI_PLUS: 'SERVIZI_PLUS',
}

export const restartSellout = (
  restartSelloutCheckpoint,
  reroute,
  stateBranch
) => {
  switch (restartSelloutCheckpoint) {
    case restartSelloutCheckpoints.SCEGLI_CANONI:
    case restartSelloutCheckpoints.SERVIZI_PLUS:
      // stateBranch e' customer
      if (
        !('email' in stateBranch) ||
        stateBranch.email === null ||
        stateBranch.email.length === 0
      ) {
        reroute('/register')
        return true
      }
      break
    default:
      break
  }
  return false
}

export const isFindomestic = product => product.finanziaria === 'Findomestic'

export const iebccUrlProxy = iebccUrl => {
  const regex = RegExp(/simulazioneId=(\d+)/, 'g')
  const matches = regex.exec(iebccUrl)
  let iebccProxiedUrl = null
  if (matches !== null && matches.length === 2) {
    const iebccId = matches[1]
    iebccProxiedUrl = `${window.brumbrum.url_api}/findomestic-iebcc/${iebccId}`
  }
  return iebccProxiedUrl
}

export const findomestic2compass = findomesticPayload => {
  const payload = findomesticPayload.presets
    ? findomesticPayload.presets
    : [findomesticPayload]

  return payload.map(finanziamento => ({
    anticipo: finanziamento.anticipo,
    data_inizio: finanziamento.inizio_validita,
    data_fine: finanziamento.fine_validita,
    iebccUrl: iebccUrlProxy(finanziamento.iebccUrl),
    id_finanziamento: extractIdFinanziamento(finanziamento),
    importo_credito: finanziamento.importoTotaleCredito,
    importo_finanziato: finanziamento.importoFinanziato,
    importo_rata: finanziamento.rata,
    importo_totale_consumatore: finanziamento.importoTotaleDovuto,
    insurance_product: finanziamento.insurance_product,
    monte_interessi: finanziamento.interessi,
    nota_legale: finanziamento.nota_legale,
    numero_rate: finanziamento.durata,
    oneri_fiscali_bollo: finanziamento.impostaBolloSostitutiva,
    oneri_fiscali_bollo_comunicazione: finanziamento.impostaBolloComunicazioni,
    premi_assicurativi: finanziamento.premi_assicurativi,
    private_employee: finanziamento.private_employee,
    residence_province: finanziamento.residence_province,
    rataAggiuntiva: finanziamento.rataAggiuntiva ?? 0,
    spese_incasso_rata: finanziamento.sir,
    spese_invio_cartaceo: finanziamento.costoComunicazioniPeriodiche,
    spese_istruttoria: finanziamento.sip,
    taeg: finanziamento.taeg,
    tan: finanziamento.tan,
    tot_interessi: finanziamento.interessi,
  }))
}

export const extractIdFinanziamento = f =>
  isDefined(f.id_finanziamento)
    ? f.id_finanziamento
    : isDefined(f.id)
    ? f.id
    : f.id_piano_rimborso

export const isDefined = v => !isNil(v)

export const proxifyEcreditUrl = url => {
  if (!url) {
    return null
  }

  return url.replace(
    /https:\/\/b2b(test)?\.ecredit\.it\/generatoreContrattoPdf\/ContrattoMulticanalitaServlet\?/,
    `${window.brumbrum.url_api}/findomestic-cga?v=${new Date().getTime()}&`
  )
}

export function isUsato(product) {
  return product.tipo_veicolo && product.tipo_veicolo.toUpperCase() === 'USATO'
}

export function isDevelop() {
  return window.brumbrum.url_www.indexOf('develop.brumbrum.it') !== -1
}

export function isLocalhost() {
  return window.brumbrum.url_www.indexOf('localhost') !== -1
}

export function getNextRoute(nextRoute, product) {
  switch (nextRoute) {
    case '/checkout':
      if (isUsato(product)) {
        return '/servizi'
      }
      return nextRoute
    default:
      return nextRoute
  }
}

export const getBrumbrumColor = () => ({
  white: '#FFFFFF',
  successMain: '#287D3C',
  errorMain: '#9B1100',
  grey800: '#212121',
  grey600: '#6B6B6B',
  blackA80: '#EBEBEB',
  blackA120: '#E0E0E0',
})
